import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { Icon, Size } from '@client';

@Component({
  selector: 'app-profile-image',
  templateUrl: './profile-image.component.html',
  standalone: true,
  imports: [CommonModule, Icon],
})
export class ProfileImageComponent {
  src = input<string>('');
  size = input<Size>('md');

  currentSize = computed(() => {
    switch (this.size()) {
      case 'sm':
        return 'size-8';
      case 'md':
        return 'size-10';
      case 'lg':
        return 'size-20';
      case 'xl':
        return 'size-24';
      default:
        return 'size-10';
    }
  });
}
